<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col>
            <h3>Seleção de Usuários</h3>
          </b-col>
        </b-row>

        <b-row align-h="between">
          <!-- Pesquisar -->
          <b-col lg="4">
            <b-form-group
              label-align="left"
              label-for="filterInput"
              label="Pesquisar usuário:"
            >
              <b-input-group>
                <b-form-input
                  v-model="filter.name"
                  type="search"
                  id="filterInput"
                  size="sm"
                ></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" :disabled="!filter.name" @click="filter.name = ''">Limpar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col cols="12" class="mt-1 mb-2">
            {{ localData.users.length === 0 ? 'Nenhum usuário selecionado' : localData.users.length === 1 ? '1 usuário selecionado' : localData.users.length + ' usuários selecionados' }}

            <!-- Botão para alternar visualização -->
            <b-link @click="toggleSelectedUsers" class="ml-3">{{ showSelectedOnly ? 'Exibir Todos' : 'Exibir Selecionados' }}</b-link>

            <a href="#" @click.prevent="localData.users = []" class="ml-3">Limpar selecionados</a>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="mt-2 mb-3">
            <!-- Listagem de usuários -->
            <b-table striped hover show-empty
              :items="getUsers"
              :fields="fields"
              primary-key="id"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentPage"
              :per-page="perPage"
              empty-filtered-text="Nenhum usuário encontrado"
              empty-text="Nenhum usuário encontrado"
              ref="table"
              responsive
            >
              <!-- Coluna: Select -->
              <template v-slot:cell(select)="data">
                <b-form-checkbox v-model="localData.users" :value="data.item.id"></b-form-checkbox>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <!-- Paginação -->
          <b-col cols="5">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>
          </b-col>

          <b-col cols="7" class="text-right">
            <b-button @click="emitPrevious" class="mr-1 px-3" variant="secondary">
              <icon name="arrow-left" scale="1" class="mr-2"></icon> Voltar
            </b-button>

            <b-button @click="emitData" class="mr-1 px-3" variant="success" :disabled="localData.users.length === 0 || isLoading">
              <icon name="save" scale="1" class="mr-2"></icon> Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>

  <script>
  export default {
    props: {
      // Determina se é edição ou criação
      isEdit: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        filter: {
          name: '',
          selectedIds: []
        },
        filterOn: [],
        showSelectedOnly: this.isEdit ? true : false,
        fields: [
          { key: 'select', label: 'Selecionar', class: ['text-center', 'align-middle'], tdClass: 'w-100px' },
          {key: 'name', label: 'Nome'},
        ],
        localData: {
          users: this.data.users || [],
        },
        isLoading: false
      };
    },
    methods: {
      async getUsers(ctx) {
        try {
          // Se estiver mostrando apenas selecionados, modifica a lógica
          if (this.showSelectedOnly && this.localData.users?.length) {
            let selectedIds = this.localData.users.join(',')
            // Adiciona os IDs selecionados como parâmetro na URL
            ctx.filter.selectedIds = selectedIds
          } else {
            this.filter.selectedIds = []
          }

          let name = ctx.filter.name ? '&name=' + ctx.filter.name : ''
          let selectedFilter = ctx.filter.selectedIds ? '&ids=' + ctx.filter.selectedIds : ''

          let url = process.env.VUE_APP_URL_APP + '/b/admin/grouped-reports/users?page=' +
                   ctx.currentPage + '&limit=' + ctx.perPage +
                   name + selectedFilter

          const resp = await this.$http.get(url)

          this.currentPage = parseInt(resp.headers.get('x-page'))
          this.totalRows = parseInt(resp.headers.get('x-total-record'))
          this.perPage = parseInt(resp.headers.get('x-limit'))

          return resp.body
        } catch (error) {
          return []
        }
      },
      emitData() {
        this.isLoading = true;
        this.$emit('update-data', this.localData);
        this.$emit('submit');
      },
      emitPrevious() {
        this.$emit('previous'); // Volta para a etapa anterior
      },
      toggleSelectedUsers() {
        this.showSelectedOnly = !this.showSelectedOnly
        this.currentPage = 1 // Reset para primeira página
        this.filter.selectedIds = []
        this.$refs.table.refresh() // Força atualização da tabela
      }
    }
  };
  </script>

<style>
.w-100px {
  width: 100px !important;
}
</style>